<template>
  <Button :label="label" icon="ti-minus" class="p-button-warning p-button-raised"/>
</template>

<script>
export default {
  name: 'ReduceButton',
  props: {
    label: String
  }
}
</script>